// Pull in the site settings from the process.env.REACT_APP env variables.
// Use this settings class in preference of the "process.env." directly as
// - It is simpler to mock
// - The build should not optimise out any feature flag statements causing possible issues with variables not defined, etc

interface ISiteSettings {
  siteApiURL: string;
  cognito: ICognitoSettings;
  frontEndVersion: string;
}

interface ICognitoSettings {
  region: string;
  userPoolId: string;
  userPoolWebClientId: string;
  domain: string;
  redirectSignIn: string;
  redirectSignOut: string;
}

// This settings object should be used in preference to the process.env. files
export const siteSettings: ISiteSettings = {
  siteApiURL: `${process.env.REACT_APP_SCALARS_URL}/api`,
  cognito: {
    region: process.env.REACT_APP_COGNITO_REGION as string,
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID as string,
    userPoolWebClientId: process.env
      .REACT_APP_COGNITO_USER_POOL_CLIENT_ID as string,
    domain: process.env.REACT_APP_COGNITO_DOMAIN as string,
    redirectSignIn: process.env.REACT_APP_COGNITO_REDIRECT_SIGN_IN as string,
    redirectSignOut: process.env.REACT_APP_COGNITO_REDIRECT_SIGN_OUT as string
  },
  frontEndVersion: process.env.REACT_APP_VERSION as string
};
